/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './describeFeedGenerator.defs.js'
export * as $defs from './describeFeedGenerator.defs.js'
